import ErrMessage from "../../core/ErrMessage.tsx";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";
import { useItem } from "../../../fetch/fetch.item.ts";
import Image from "../../core/image/Image";
import ImageMissing from "../../core/image/ImageMissing";

const ItemImage = ({
  className,
  id,
  sizes,
}: {
  className?: string;
  id: string;
  sizes?: string;
}) => {
  const { item, isLoading, isError } = useItem(id, EMPTY_ITEM);
  if (isLoading) {
    return <div className={`skeleton animate-pulse ${className}`}></div>;
  }
  if (isError) return <ErrMessage message={isError} />;
  if (item.imageUrls.length === 0) {
    return <ImageMissing />;
  }
  return (
    <Image
      alt={`Image of ${item.title}`}
      className={className}
      src={item.imageUrls[0]}
      sizes={sizes}
      loading="lazy"
    />
  );
};
export default ItemImage;
